<template>
  <div class="inSchool">
    <div class="title_style">{{ $t(`educationSystem.bread.first`) }}</div>
    <div class="kinder_style">
      <img :src="$t(`educationSystem.imgArr`)[0]" class="kinder_imgTop_style" />
      <div class="kinder">
        <div class="kinder_title_style">
          <div
            class="kinder_title_style_item"
            :title="$t(`educationSystem.schoolEducation.firstArr`)[0].title"
          >{{ $t(`educationSystem.schoolEducation.firstArr`)[0].title }}</div>
        </div>
        <div class="kinder_content">
          <div
            class="kinder_content_style"
            :title="$t(`educationSystem.schoolEducation.firstArr`)[0].content"
          >{{ $t(`educationSystem.schoolEducation.firstArr`)[0].content }}</div>
          <div class="kinder_design_style1">
            <span class="kinder_design_title_style">
              {{
              $t(`educationSystem.bread.second`)
              }}
            </span>
            <span :title="$t(`educationSystem.bread.second_content`)">
              {{
              $t(`educationSystem.bread.second_content`)
              }}
            </span>
          </div>
          <div class="kinder_design_style">
            <span class="kinder_design_title_style">
              {{
              $t(`educationSystem.bread.three`)
              }}
            </span>
            <span :title="$t(`educationSystem.bread.three_content`)">
              {{
              $t(`educationSystem.bread.three_content`)
              }}
            </span>
          </div>
          <div class="kinder_design_style">
            <span class="kinder_design_title_style">
              {{
              $t(`educationSystem.bread.fourth`)
              }}
            </span>
            <span :title="$t(`educationSystem.bread.fourth_content`)">
              {{
              $t(`educationSystem.bread.fourth_content`)
              }}
            </span>
          </div>
        </div>
        <div style="margin-top: 0.1rem;" class="look_more_style" @click="toClick(0)">
          {{ $t(`educationSystem.bread.fifth`) }}
          >
        </div>
      </div>
      <img src="../../../static/img/kindergarten.png" class="kinder_img_style" />
    </div>
    <div class="kinder_style1">
      <img :src="$t(`educationSystem.imgArr`)[1]" class="kinder_imgTop_style" />
      <div class="kinder">
        <div class="kinder_title_style">
          <div
            class="kinder_title_style_item"
            :title="$t(`educationSystem.schoolEducation.firstArr`)[1].title"
          >{{ $t(`educationSystem.schoolEducation.firstArr`)[1].title }}</div>
        </div>
        <div class="kinder_content" style="margin-top: 0.52rem;height: 2.92rem;">
          <div
            class="kinder_content_style"
            :title="$t(`educationSystem.schoolEducation.firstArr`)[1].content"
          >{{ $t(`educationSystem.schoolEducation.firstArr`)[1].content }}</div>
        </div>
        <div class="look_more_style" @click="toClick(1)">{{ $t(`educationSystem.bread.fifth`) }}></div>
      </div>
      <img src="../../../static/img/smallSchool.png" class="kinder_img_style" />
    </div>
    <div class="kinder_style1" style="margin-bottom:1.26rem">
      <img :src="$t(`educationSystem.imgArr`)[2]" class="kinder_imgTop_style" />
      <div class="kinder">
        <div class="kinder_title_style">
          <div
            class="kinder_title_style_item"
            :title="$t(`educationSystem.schoolEducation.firstArr`)[2].title"
          >{{ $t(`educationSystem.schoolEducation.firstArr`)[2].title }}</div>
        </div>
        <div class="kinder_content" style="margin-top: 0.52rem;height: 2.92rem;">
          <div
            class="kinder_content_style"
            :title="$t(`educationSystem.schoolEducation.firstArr`)[2].content"
          >{{ $t(`educationSystem.schoolEducation.firstArr`)[2].content }}</div>
        </div>
        <div class="look_more_style" @click="toClick(2)">{{ $t(`educationSystem.bread.fifth`) }}></div>
      </div>
      <img src="../../../static/img/midSchool.png" class="kinder_img_style" />
    </div>
  </div>
</template>

<script>
//引入底部子组件
// import Banner from '../layout/banner'
// import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  metaInfo: {
    title: '校内教育--金成英特教育', // set a title
    meta: [{                 // set meta
      name: '校内教育--金成英特教育'
    }]
  },
  name: 'inSchool',
  data () {
    return {}
  },
  created () { },
  computed: {},
  mounted () {
    let that = this
    if (this.$route.query.type) {
      this.$emit('typeChange', this.$route.query.type)
    }
  },
  methods: {
    toClick (index) {
      console.log('/'+this.$store.state.language+'/kindergarten')
      switch (index) {
        case 0:
          this.$router.push({
            path: '/'+this.$store.state.language+'/kindergarten'
          })
          break
        case 1:
          this.$router.push({
            path: '/'+this.$store.state.language+'/smallSchool'
          })
          break
        case 2:
          this.$router.push({
            path: '/'+this.$store.state.language+'/middleSchool'
          })
          break
        default:
          break
      }
    }
  }
}
</script>

<style scoped="scoped">
.title_style {
  color: #0a508f;
  font-size: 0.28rem;
  font-weight: bold;
}

.kinder_style {
  background: #ffffff;
  width: 7.98rem;
  height: 4.49rem;
  margin-top: 0.83rem;
  position: relative;
}

.kinder_style1 {
  background: #ffffff;
  width: 7.98rem;
  height: 4.49rem;
  margin-top: 0.81rem;
  position: relative;
}

.kinder_imgTop_style {
  width: 1.35rem;
  height: 1.35rem;
  /* margin-left: -0.1rem;
  margin-top: -0.05rem; */
  /* float: left; */
  position: absolute;
  left: -0.1rem;
  top: -0.05rem;
}

.kinder_img_style {
  float: right;
  height: 4.49rem;
  width: 3.61rem;
}

.kinder {
  float: left;
}

.kinder_title_style {
  margin-top: 0.45rem;
  font-size: 0.15rem;
  font-weight: bold;
  color: #3f3f3f;
  width: 4.37rem;
  text-align: center;
}
.kinder_title_style_item {
  width: 3rem;
  /* white-space: nowrap; */
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
}

.kinder_content {
  width: 4.37rem;
  font-size: 0.14rem;
  margin-top: 0.35rem;
  color: #3f3f3f;
  padding: 0 0.26rem;
  box-sizing: border-box;
}

.kinder_content_style {
  color: #3f3f3f;
  line-height: 0.24rem;
  display: -webkit-box;
  -webkit-line-clamp: 8;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  text-align: justify;
}

.kinder_design_style1 {
  margin-top: 0.28rem;
  line-height: 0.24rem;
  width: 3.74rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.kinder_design_style {
  margin-top: 0.04rem;
  /* width: 3.74rem; */
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.kinder_design_title_style {
  font-weight: bold;
}

.look_more_style {
  color: #0a508f;
  float: right;
  font-size: 0.12rem;
  transform: scale(0.75);
  cursor: pointer;
  margin-right: 0.18rem;
  letter-spacing: 0.01rem;
}
</style>



// WEBPACK FOOTER //
// src/components/system/inSchool.vue